import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import axios from "axios";

// helpers/services in your project
import { authHeader } from "_helpers";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { Label, Input, FormGroup } from "reactstrap";
import Datetime from "react-datetime";

// core components (match your project structure)
import Grid from "components/Grid/GridContainer";
import Col from "components/Grid/GridItem";
import TSText from "components/Forms/TSText";
import TSSelect2 from "components/Forms/TSSelect2";
import TSUser from "components/Forms/TSUser";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import { Collapse, Modal, ModalBody } from "reactstrap";

import IconButton from '@material-ui/core/IconButton';

import {
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper, TableSortLabel, TableFooter, TablePagination,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core';

import "react-datetime/css/react-datetime.css";
import "./custom-style.css";
import zIndex from "@material-ui/core/styles/zIndex";

// ===================== Styles =====================
const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: 0,
    fontSize: "14px",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: 0,
    minHeight: "auto",
    fontWeight: 300,
    fontFamily: '"Sarabun", sans-serif',
    marginBottom: "3px",
    textDecoration: "none",
  },
  cardTitleCustom: {
    background: "linear-gradient(to right, #2193b0, #6dd5ed)",
    margin: "-20px 15px 15px 15px",
  },
  tableContainer: { maxHeight: 520 },
  tableRow: { cursor: "pointer" },
  margin: {
    color: '#fff'
  },
};
const useStyles = makeStyles(styles);

// ===================== Component =====================
const Agenda = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const user = useSelector((state) => state.auth.user);
  const { location } = props;

  const moment = require("moment");
  require("moment/locale/th");

  // ------- List State -------
  const [dataList, setDataList] = useState([]);
  const [isShowList, setIsShowList] = useState(true);
  const [orderBy, setOrderBy] = useState("meetingYear");
  const [orderDirection, setOrderDirection] = useState("desc");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // ------- Filters (เหมือนแนว TeamGroup.js เน้น TextField + state) -------
  const [FilterYear, setFilterYear] = useState((new Date().getFullYear())+543);
  const [FilterSeq, setFilterSeq] = useState("");
  const [FilterTitle, setFilterTitle] = useState("");

  // ------- Form State -------
  const [AgendaID, setAgendaID] = useState(null); // GUID เมื่อแก้ไข
  const [TeamGroupKey, setTeamGroupKey] = useState(null);
  const [MeetingSeq, setMeetingSeq] = useState("");
  const [MeetingYear, setMeetingYear] = useState((new Date().getFullYear())+543);
  const [Description, setDescription] = useState("");

  // Child: MeetingAgendaItem (dynamic rows)
  const [Items, setItems] = useState([]); // เริ่มว่าง เพื่อบังคับให้เพิ่มผ่าน Card แต่ละใบ

  // Lookups
  const [ArrTeamGroup, setArrTeamGroup] = useState([]);
  const [ArrAgendaHeader, setArrAgendaHeader] = useState([]);
  const DECISIONS = [
    { value: -1, label: "ไม่เห็นด้วย" },
    { value: 1, label: "เห็นด้วย" },
    { value: 2, label: "รับทราบ" },
    { value: 3, label: "พิจารณาครั้งถัดไป" },
    ];

    const fileIcon = (name, ct) => {
        const ext = (name?.split('.').pop() || '').toLowerCase();
        if ((ct || '').startsWith('image/') || ['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp'].includes(ext)) return 'far fa-file-image';
        if (ct === 'application/pdf' || ext === 'pdf') return 'far fa-file-pdf';
        if (['doc', 'docx'].includes(ext)) return 'far fa-file-word';
        if (['xls', 'xlsx', 'csv'].includes(ext)) return 'far fa-file-excel';
        if (['ppt', 'pptx'].includes(ext)) return 'far fa-file-powerpoint';
        if (['zip', 'rar', '7z', 'gz', 'tar'].includes(ext)) return 'far fa-file-archive';
        if (['mp4', 'mov', 'avi', 'mkv', 'webm'].includes(ext)) return 'far fa-file-video';
        if (['mp3', 'wav', 'm4a', 'aac', 'flac', 'ogg'].includes(ext)) return 'far fa-file-audio';
        return 'far fa-file';
    };

  // Modals
  const [modal, setModal] = useState(false);         // confirm save
  const [modal2, setModal2] = useState(false);       // success
  const [modalError, setModalError] = useState(false);
  const [modalCancel, setModalCancel] = useState(false);
  const [errMsg, setErrMsg] = useState([]);
  const [icon, setIcon] = useState("far fa-question-circle");

  // ===================== Effects =====================
  useEffect(() => {
    loadList();
    loadLookups();
  }, []);

  const loadLookups = async () => {
    // TeamGroup
    axios("/api/v1/team/teamgroup").then(
      (res) => {
        const data = res?.data?.data ?? [];
        const json = JSON.parse(
          JSON.stringify(data)
            .split('"name":').join('"label":')
            .split('"teamGroupKey":').join('"value":')
        );
        setArrTeamGroup(json);
      },
      (e) => console.log(e)
    );

    // AgendaHeader
    axios("/api/v1/meeting/agendaheader").then(
      (res) => {
        const data = res?.data?.data ?? [];
        const json = data.map((x) => ({ value: x.agendaHeaderKey || x.value, label: `${x.agendaNo || ''} - ${x.agendaName || ''}` }));
        setArrAgendaHeader(json);
      },
      (e) => console.log(e)
    );
  };

  const loadList = async () => {
    try {
      const params = {};
      if (FilterYear) params.MeetingYear = FilterYear;
      if (FilterSeq) params.MeetingSeq = FilterSeq;
      if (FilterTitle) params.Title = FilterTitle;
      const res = await axios.get(`/api/v1/meetingagenda`, { params });
      setDataList(res?.data?.data ?? []);
    } catch (e) {
      console.error(e);
    }
  };

  // ===================== List Utils =====================
  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && orderDirection === "asc";
    setOrderDirection(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedData = () => {
    const arr = [...dataList];
    return arr.sort((a, b) => {
      const A = a[orderBy];
      const B = b[orderBy];
      if (orderDirection === "asc") return A < B ? -1 : 1;
      return A > B ? -1 : 1;
    });
  };

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => { setRowsPerPage(parseInt(event.target.value, 10)); setPage(0); };

  // ===================== List -> Edit =====================
  const handleAdd = () => {
    setIsShowList(false);
    clearForm();
  };

  const clearForm = () => {
    setAgendaID(null);
    setTeamGroupKey(null);
    setMeetingSeq("");
    setMeetingYear((new Date().getFullYear())+543);
    setDescription("");
    setItems([]); // เคลียร์ให้ว่าง
  };

  const handleEdit = async (index, row) => {
    try {
      const res = await axios.get(`/api/v1/meetingagenda/${row.agendaID || row.AgendaID}`);
      const a = res?.data?.data;
      if (!a) return;
      setAgendaID(a.agendaID || a.AgendaID);
      setTeamGroupKey(a.teamGroupKey ?? null);
      setMeetingSeq(a.meetingSeq ?? "");
      setMeetingYear(a.meetingYear ?? (new Date().getFullYear())+543);
      setDescription(a.description ?? "");
      setItems(
          (a.meetingAgendaItem || a.MeetingAgendaItem || []).map((it) => ({
          AgendaItemID: it.agendaItemID || it.AgendaItemID || null,
          AgendaHeaderKey: it.agendaHeaderKey ?? it.AgendaHeaderKey ?? null,
          ItemNo: it.itemNo ?? it.ItemNo ?? "",
          Subject: it.subject ?? it.Subject ?? "",
          Content: it.content ?? it.Content ?? "",
          Suggestion: it.suggestion ?? it.Suggestion ?? "",
          DecisionKey: it.decisionKey ?? it.DecisionKey ?? null,
          DecisionNote: it.decisionNote ?? it.DecisionNote ?? "",
          UserName: it.userName ?? it.UserName ?? "",
          attachments: [], // ไฟล์ที่ "จะอัปโหลด"
          uploaded: (it.meetingAgendaAttachment || it.MeetingAgendaAttachment || []).map(x => ({
          attachmentID: x.attachmentID || x.AttachmentID,
                           fileName: x.fileName || x.FileName,
                           contentType: x.contentType || x.ContentType,
                           size: x.size || x.Size,
                           objectKey: x.objectKey || x.ObjectKey,   // <— สำคัญ: ใช้เป็น index สำหรับดาวน์โหลด
                           agendaItemID: it.agendaItemID || it.AgendaItemID
          })),
        }))
        );

      setIsShowList(false);
    } catch (e) {
      console.error(e);
    }
  };

  // ===================== Form: Items handlers =====================
  //const addItem = () => setItems((p) => ([...p, { AgendaHeaderKey: null, ItemNo: "", Subject: "", Content: "", Suggestion: "", DecisionKey: null, DecisionNote: "", UserName: "", attachments: [] }]));
    const addItem = () => setItems((p) => ([...p, { AgendaItemID: null, AgendaHeaderKey: null, ItemNo: "", Subject: "", Content: "", Suggestion: "", DecisionKey: null, DecisionNote: "", UserName: "", attachments: [] }]));
    //const addItemForHeader = (fixedKey) => setItems((p) => ([...p, { AgendaHeaderKey: fixedKey, ItemNo: "", Subject: "", Content: "", Suggestion: "", DecisionKey: null, DecisionNote: "", UserName: "", attachments: [] }]));
    const addItemForHeader = (fixedKey) => setItems((p) => ([...p, { AgendaItemID: null, AgendaHeaderKey: fixedKey, ItemNo: "", Subject: "", Content: "", Suggestion: "", DecisionKey: null, DecisionNote: "", UserName: "", attachments: [] }]));
    const removeItem = (idx) => setItems((p) => p.filter((_, i) => i !== idx));
  const changeItem = (idx, key, value) => setItems((p) => p.map((it, i) => (i === idx ? { ...it, [key]: value } : it)));

  const pushAttachment = (idx, files) => {
    const arr = Array.from(files || []);
    setItems((p) => p.map((it, i) => (i === idx ? { ...it, attachments: [...(it.attachments || []), ...arr.map((f) => ({ name: f.name, file: f }))] } : it)));
  };
  
  const removeAttachment = (idx, aIdx) => setItems((p) => p.map((it, i) => (i === idx ? { ...it, attachments: it.attachments.filter((_, j) => j !== aIdx) } : it)));

  const headerLabel = (key) => {
    const f = ArrAgendaHeader.find((x) => Number(x.value) === Number(key));
    return f ? `${f.label}` : `AgendaHeaderKey ${key}`;
  };

  // ===================== Submit =====================
  const handleSubmit = (evt) => {
    evt.preventDefault();
    let cntErr = 0;
    const msgs = [];

    if (!TeamGroupKey) { cntErr++; msgs.push(<li key={cntErr - 1}>กรุณาเลือกคณะกรรมการ/หน่วยงาน</li>); }
    if (!MeetingSeq || Number(MeetingSeq) <= 0) { cntErr++; msgs.push(<li key={cntErr - 1}>กรุณาระบุครั้งที่</li>); }
    if (!MeetingYear || Number(MeetingYear) <= 2000) { cntErr++; msgs.push(<li key={cntErr - 1}>กรุณาระบุปี</li>); }

    // ตรวจอย่างน้อยมี 1 วาระย่อย และทุกแถวต้องเลือกวาระหลัก
    if (!Items || Items.length === 0) { cntErr++; msgs.push(<li key={cntErr - 1}>กรุณาเพิ่มวาระย่อยอย่างน้อย 1 ข้อ</li>); }
    Items.forEach((it, i) => {
      if (!it.AgendaHeaderKey) { cntErr++; msgs.push(<li key={cntErr - 1}>วาระย่อยลำดับ {i + 1}: กรุณาเลือกวาระหลัก</li>); }
    });

    if (cntErr > 0) { setErrMsg(msgs); setModalError(true); return; }
    setModal(true);
  };

  const handleConfirm = async (evt) => {
    evt.preventDefault();
    setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");

    try {
      const Title = `ประชุม ${(ArrTeamGroup.find(x => x.value === TeamGroupKey)?.label || "")} ครั้งที่ ${MeetingSeq}/${MeetingYear}`; // gen ชื่อรายงานการประชุมอัตโนมัติ

      const payload = {
        teamGroupKey: Number(TeamGroupKey),
        meetingSeq: Number(MeetingSeq),
        meetingYear: Number(MeetingYear),
        title: Title,
        description: Description || "",
          //meetingAgendaItem: Items.map((it) => ({
        meetingAgendaItem: Items.map((it) => {
            const obj = {
                ...(it.AgendaItemID ? { agendaItemId: it.AgendaItemID } : {}), // << สำคัญ
                agendaHeaderKey: Number(it.AgendaHeaderKey),
                itemNo: it.ItemNo || "",
                subject: it.Subject || "",
                content: it.Content || "",
                suggestion: it.Suggestion || "",
                decisionKey: it.DecisionKey != null ? Number(it.DecisionKey) : null,
                decisionNote: it.DecisionNote || "",
                userName: it.UserName || "",
                //meetingAgendaAttachment: [], // TODO: แนบหลังมี endpoint upload
                //})),
            };
            return obj
           }),
        };


      const created = AgendaID
        ? await axios.put(`/api/v1/meetingagenda/${AgendaID}`, payload)
        : await axios.post(`/api/v1/meetingagenda`, payload);

      const d = created?.data?.data || {};
      const newAgendaId = d.agendaID || d.AgendaID || AgendaID;  // กรณีแก้ไข
      setAgendaID(newAgendaId);
      const apiItems = d.meetingAgendaItem || d.MeetingAgendaItem || [];

      await uploadAllItemFiles(newAgendaId, apiItems);


      /*
      if (AgendaID) {
        await axios.put(`/api/v1/meetingagenda/${AgendaID}`, payload);
      } else {
        const created = await axios.post(`/api/v1/meetingagenda`, payload);
        const d = created?.data?.data || {};
        setAgendaID(d.agendaID || d.AgendaID || null);
      }*/

      setIcon("far fa-question-circle");
      setModal(false);
      setModal2(true);
    } catch (e) {
      console.error(e);
      setIcon("far fa-question-circle");
      setModal(false);
      setErrMsg([e?.response?.data?.msg || e?.message || "บันทึกไม่สำเร็จ"]);
      setModalError(true);
    }
  };


  async function uploadAllItemFiles(agendaId, apiItems) {
  // apiItems = array จาก response (มี agendaItemID)
  // จับคู่กับ state Items ของเรา ด้วย index/เงื่อนไข (เช่น AgendaHeaderKey + ItemNo + Subject)
  for (let i = 0; i < apiItems.length; i++) {
    const apiItem = apiItems[i];
    // หาแถวใน state ที่ “ตรง” กับแถวที่เพิ่งสร้าง (ตัวอย่าง: match ด้วย AgendaHeaderKey+ItemNo+Subject)
    const matchIdx = Items.findIndex(it =>
      Number(it.AgendaHeaderKey) === Number(apiItem.agendaHeaderKey) &&
      `${it.ItemNo || ''}`.trim() === `${apiItem.itemNo || ''}`.trim() &&
      `${it.Subject || ''}`.trim() === `${apiItem.subject || ''}`.trim()
    );
    if (matchIdx === -1) continue;

    const files = Items[matchIdx].attachments || [];
    if (!files.length) continue;

    const fd = new FormData();
    files.forEach(f => fd.append('files', f.file)); // append หลายไฟล์
    // fd.append('note', 'หมายเหตุแนบไฟล์ถ้าต้องการ');

    await axios.post(
      `/api/v1/meetingagenda/${agendaId}/items/${apiItem.agendaItemID}/attachments`,
      fd,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
  }
}

  const GotoList = () => {
    setModal2(false);
    setIsShowList(true);
    loadList();
  };

  // ===================== Render =====================
  return (
    <div className="content">
      <Grid>
        {/* ===== List ===== */}
        <Col xs={12} sm={12} md={12} style={{ display: isShowList ? 'block' : 'none' }}>
          <Card>
            <CardHeader color="primary">
              <h4 className={classes.cardTitleWhite}>รายการวาระการประชุม (MeetingAgenda)</h4>
              <p className={classes.cardCategoryWhite}>ค้นหาด้วย ปี/ครั้งที่/ชื่อรายงานการประชุม</p>
            </CardHeader>
            <CardBody>
              <Grid>
                <Col xs={12} sm={6} md={2}>
                  <TSText icon="far fa-calendar" label="ปี (CE)" type="number" value={FilterYear} onChange={(e) => setFilterYear(e.target.value)} />
                </Col>
                <Col xs={12} sm={6} md={2}>
                  <TSText icon="far fa-hashtag" label="ครั้งที่" type="number" value={FilterSeq} onChange={(e) => setFilterSeq(e.target.value)} />
                </Col>
                <Col xs={12} sm={12} md={4}>
                  <TSText icon="far fa-file-alt" label="ชื่อรายงานการประชุม (Title)" value={FilterTitle} onChange={(e) => setFilterTitle(e.target.value)} />
                </Col>
                <Col xs={12} sm={12} md={2}>
                  <Button color="primary" type="button" onClick={loadList}><h4><i className={"fa fa-search"}></i> ค้นหา</h4></Button>
                </Col>
                <Col xs={12} sm={12} md={2}>
                  <Button color="success" type="button" onClick={handleAdd}><h4><i className={"fa fa-plus"}></i> สร้างรายงานการประชุม</h4></Button>
                </Col>
                <Col xs={12}>
                  <TableContainer component={Paper} className={classes.tableContainer}>
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell>
                            <TableSortLabel active={orderBy === 'title'} direction={orderBy === 'title' ? orderDirection : 'asc'} onClick={() => handleRequestSort('title')}>
                              ชื่อรายงานการประชุม
                            </TableSortLabel>
                          </TableCell>
                          <TableCell>
                            <TableSortLabel active={orderBy === 'meetingSeq'} direction={orderBy === 'meetingSeq' ? orderDirection : 'asc'} onClick={() => handleRequestSort('meetingSeq')}>
                              ครั้งที่
                            </TableSortLabel>
                          </TableCell>
                          <TableCell>
                            <TableSortLabel active={orderBy === 'meetingYear'} direction={orderBy === 'meetingYear' ? orderDirection : 'asc'} onClick={() => handleRequestSort('meetingYear')}>
                              ปี
                            </TableSortLabel>
                          </TableCell>
                          <TableCell>จำนวนวาระย่อย</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {sortedData()
                          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                          .map((data, index) => (
                            <TableRow key={index} className={classes.tableRow}>
                              <TableCell>
                                <Label style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={() => handleEdit(index, data)}>
                                  {data.title || data.Title}
                                </Label>
                              </TableCell>
                              <TableCell>{data.meetingSeq || data.MeetingSeq}</TableCell>
                              <TableCell>{data.meetingYear || data.MeetingYear}</TableCell>
                              <TableCell>{(data.meetingAgendaItem || data.MeetingAgendaItem || []).length}</TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                      <TableFooter>
                        <TableRow>
                          <TablePagination
                            rowsPerPageOptions={[10, 25, 50]}
                            count={dataList.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                          />
                        </TableRow>
                      </TableFooter>
                    </Table>
                  </TableContainer>
                </Col>
              </Grid>
            </CardBody>
            <CardFooter></CardFooter>
          </Card>
        </Col>

        {/* ===== Form ===== */}
        <Col xs={12} sm={12} md={12} style={{ display: !isShowList ? 'block' : 'none' }}>
          <Card>
            <CardHeader className={classes.cardTitleCustom}>
              <h4 className={classes.cardTitleWhite}>บันทึกรายงานการประชุม</h4>
              <p className={classes.cardCategoryWhite}>กรุณาระบุรายละเอียดให้ครบถ้วน</p>
            </CardHeader>
            <CardBody>
              <Grid>
                <Col xs={12} sm={12} md={6}>
                  <TSSelect2
                    label="คณะกรรมการ/หน่วยงาน (TeamGroupKey)"
                    options={ArrTeamGroup}
                    value={TeamGroupKey}
                    onChange={(e) => setTeamGroupKey(e?.value || null)}
                    zIndex={5}
                  />
                </Col>
                <Col xs={6} sm={6} md={3}>
                  <TSText icon="far fa-hashtag" label="ครั้งที่" type="number" value={MeetingSeq} onChange={(e) => setMeetingSeq(e.target.value)} /> 
                </Col>
                <Col xs={6} sm={6} md={3}>
                  <TSText icon="far fa-calendar" label="/ปี  " type="number" value={MeetingYear} onChange={(e) => setMeetingYear(e.target.value)} />
                </Col>
                <Col xs={12}>
                  <TSText icon="far fa-file-alt" label="คำอธิบาย (Description)" value={Description} onChange={(e) => setDescription(e.target.value)} multiline={true} rows={3} />
                </Col>

                {/* ===== Agenda Items (แบบ 6 Card ตาม AgendaHeaderKey 1..6) ===== */}

                <Grid><Col>&nbsp;</Col></Grid>

                <Col xs={12}>
                  <Button color="success" type="button" onClick={handleSubmit}>
                    <h4><i className={"fa fa-save"}></i> บันทึก</h4>
                  </Button>
                  <Button color="warning" type="button" onClick={() => setIsShowList(true)}>
                    <h4><i className={"fa fa-list"}></i> กลับหน้าหลัก</h4>
                  </Button>
                </Col>
              </Grid>
            </CardBody>
          </Card>
        </Col>




        {[1, 2, 3, 4, 5, 6].map((H) => (
          <Col key={`H-${H}`} xs={12} sm={12} md={12} style={{ display: !isShowList ? 'block' : 'none' }}>
            <Card>
              <CardHeader color="primary">

                <Grid>
                  <Col xs={12} sm={8} md={10}>
                    <h4 className={classes.cardTitleWhite}>{headerLabel(H)}</h4>
                    <p className={classes.cardCategoryWhite}></p>
                  </Col>

      

                  <Col xs={12} sm={4} md={2} style={{ textAlign: 'right' }}>
                    <IconButton aria-label="delete" className={classes.margin} onClick={() => addItemForHeader(H)}>
                      <i className={"fa fa-plus"}></i>
                    </IconButton>
                  </Col>
                </Grid>



         
              </CardHeader>
              <CardBody>
                <Grid>
                  {Items
                    .map((it, idx) => ({ it, idx }))
                    .filter(({ it }) => Number(it.AgendaHeaderKey) === Number(H))
                    .map(({ it, idx }) => (
                      <Col key={`item-${H}-${idx}`} xs={12} sm={12} md={12} style={{ border: '1px dashed #ccc', padding: 10, marginTop: 12 }}>
                        <Grid>
                          {/* Fixed header label */}
                          <Col xs={12} sm={6} md={4}>
                            <TSText icon="far fa-list-ol" label="วาระย่อย (ItemNo)" value={it.ItemNo} onChange={(e) => changeItem(idx, 'ItemNo', e.target.value)} />
                          </Col>
                          <Col xs={12} sm={6} md={8}>
                            <TSText icon="far fa-comment" label="เรื่อง (Subject)" value={it.Subject} onChange={(e) => changeItem(idx, 'Subject', e.target.value)} />
                          </Col>
                          <Col xs={12}>
                            <div className="textarea-container" style={{ padding: 0 }}>
                                                                    <Label for="Content">รายละเอียด </Label>  
                                                                    <Input
                                                                        id="Content"
                                                                        cols="80"
                                                                        name="Content"
                                                                        placeholder="รายละเอียด"
                                                                        rows="4"
                                                                        type="textarea"
                                                                        className="custom"
                                                                        style={{ fontSize: '1.2em', maxHeight: '150px' }}
                                                                        value={it.Content}
                                                                        onChange={(e) => changeItem(idx, 'Content', e.target.value)}
                                                                        ></Input>
                            </div>
                          </Col>
                          <Col xs={12}>
                            <div className="textarea-container" style={{ padding: 0 }}>
                                                                    <Label for="Suggestion">ข้อเสนอแนะ </Label>  
                                                                    <Input
                                                                        id="Suggestion"
                                                                        cols="80"
                                                                        name="Suggestion"
                                                                        placeholder="รายละเอียด"
                                                                        rows="4"
                                                                        type="textarea"
                                                                        className="custom"
                                                                        style={{ fontSize: '1.2em', maxHeight: '150px' }}
                                                                        value={it.Suggestion}
                                                                        onChange={(e) => changeItem(idx, 'Suggestion', e.target.value)}
                                                                        ></Input>
                            </div>
                          </Col>

                          <Col xs={12} sm={4} md={4}>
                            <TSSelect2
                              label="มติกรรมการ (DecisionKey)"
                              options={DECISIONS.map((d) => ({ value: d.value, label: d.label }))}
                              value={it.DecisionKey}
                              onChange={(e) => changeItem(idx, 'DecisionKey', e?.value ?? null)}
                              zIndex={3}
                            />
                          </Col>
                          <Col xs={12} sm={4} md={4}>
                            <TSText icon="far fa-sticky-note" label="หมายเหตุมติ (DecisionNote)" value={it.DecisionNote} onChange={(e) => changeItem(idx, 'DecisionNote', e.target.value)} />
                          </Col>
                          <Col xs={12} sm={4} md={4}>
                            <TSText icon="far fa-user" label="ผู้นำเสนอ/เจ้าของเรื่อง (UserName)" value={it.UserName} onChange={(e) => changeItem(idx, 'UserName', e.target.value)} />
                          </Col>
                          <Col xs={12}>
                         {/* --- รายชื่อไฟล์ที่อัปโหลดแล้ว --- */}
                             {(it.uploaded && it.uploaded.length > 0) && (
                               <div style={{ marginTop: 10 }}>
                                 <Label style={{ display: 'block', fontWeight: 600 }}>
                                   ไฟล์ที่อัปโหลดแล้ว
                                 </Label>
                                 {it.uploaded.map((f, uIdx) => (
                                   <div key={uIdx} style={{ marginBottom: 6 }}>
                                     {/* ลิงก์ดาวน์โหลด: เรียก API โดยใช้ FileObjectKey เป็น index */}
                                     <a
                                       href={`/api/v1/files/${encodeURIComponent(f.objectKey)}`}
                                       target="_blank"
                                       rel="noopener noreferrer"
                                       style={{ textDecoration: 'underline' }}
                                     >
                                       <i className={fileIcon(f.fileName, f.contentType)} style={{ marginRight: 6 }} />
                                       {f.fileName}
                                     </a>
                                     {/* ปุ่มลบไฟล์แนบที่อัปโหลดแล้ว (ถ้าต้องการ) */}
                                     <i
                                       className="fa fa-trash"
                                       title="ลบไฟล์"
                                       style={{ marginLeft: 10, cursor: 'pointer', color: '#c00' }}
                                       /*
                                       onClick={() => deleteUploadedFile(
                                          AgendaID,
                                          f.agendaItemID,
                                          f.attachmentID,
                                          idx
                                             )}
                                       */
                                     />
                                   </div>
                                 ))}
                               </div>
                             )}
                            <FormGroup>
                              <Label>แนบไฟล์ (หลายไฟล์ได้)</Label>
                              <Input type="file" multiple onChange={(e) => pushAttachment(idx, e.target.files)} />
                              <div style={{ marginTop: 6 }}>
                                {(it.attachments || []).map((a, aIdx) => (
                                  <Label key={aIdx} style={{ marginRight: 8 }}>
                                    <i className="fa fa-paperclip"></i> {a.name}
                                    <i className="fa fa-times" style={{ marginLeft: 6, cursor: 'pointer' }} onClick={() => removeAttachment(idx, aIdx)}></i>
                                  </Label>
                                ))}
                              </div>
                            </FormGroup>
                          </Col>
                          <Col xs={12}>
                            <Button color="danger" type="button" onClick={() => removeItem(idx)}>
                              <h4><i className={"fa fa-trash"}></i> ลบวาระย่อย</h4>
                            </Button>
                          </Col>
                        </Grid>
                      </Col>
                    ))}
                </Grid>
              </CardBody>
              <CardFooter></CardFooter>
            </Card>
          </Col>

        ))}






      </Grid>

      {/* ===== Modals ===== */}
      <CardFooter>
        <Collapse isOpen={false}></Collapse>

        {/* Confirm */}
        <Modal toggle={() => setModal(false)} isOpen={modal}>
          <div className="modal-header justify-content-center">
            <div>
              <i className={icon} style={{ color: "blue", fontSize: "2em" }}></i>
            </div>
          </div>
          <ModalBody>
            <p style={{ textAlign: "center", fontSize: "1.8em" }}>
              {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg" ? "ยืนยันการบันทึกข้อมูล" : "กำลังตรวจสอบข้อมูล"}
            </p>
          </ModalBody>
          <div className="modal-footer">
            <Button color="success" type="button" onClick={handleConfirm} disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}>
              <i className={"fa fa-thumbs-up"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }}></i>
              <h4>ยืนยัน</h4>
            </Button>
            <Button color="danger" type="button" onClick={() => { setIcon("far fa-question-circle"); setModal(false); }}>
              <i className={"fa fa-thumbs-down"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }}></i>
              <h4>ยกเลิก</h4>
            </Button>
          </div>
        </Modal>

        {/* Success */}
        <Modal toggle={GotoList} isOpen={modal2}>
          <div className="modal-header justify-content-center">
            <div>
              <i className={"fas fa-check"} style={{ color: "green", fontSize: "4em" }}></i>
            </div>
          </div>
          <ModalBody>
            <p style={{ textAlign: "center", fontSize: "1.8em" }}>บันทึกข้อมูลสำเร็จ</p>
          </ModalBody>
          <div className="modal-footer">
            <Button color="info" type="button" onClick={GotoList}>
              <i className={"fa fa-thumbs-up"} style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }}></i>
              <h4>ตกลง</h4>
            </Button>
          </div>
        </Modal>

        {/* Error */}
        <Modal toggle={() => setModalError(false)} isOpen={modalError}>
          <div className="modal-header justify-content-center">
            <div>
              <i className={"fas fa-exclamation-triangle"} style={{ color: "red", fontSize: "4em" }}></i>
            </div>
          </div>
          <ModalBody>
            <div style={{ textAlign: "left", fontSize: "1.2em" }}>
              <ul>{errMsg}</ul>
            </div>
          </ModalBody>
          <div className="modal-footer justify-content-center">
            <Button color="primary" type="button" onClick={() => setModalError(false)}>
              <h4>ตกลง</h4>
            </Button>
          </div>
        </Modal>
      </CardFooter>
    </div>
  );
};

export default Agenda;
